import type { BaseKeyFunction } from "../../../../../lib/types/baseKeyFunction";

export type KeyCommunityAssignmentProps = {
  assignmentId: number;
  classId: number;
};

export const keyCommunityAssignment: BaseKeyFunction<
  KeyCommunityAssignmentProps
> = ({ assignmentId, classId }) => [
  "community-assignment",
  classId.toString(),
  assignmentId.toString(),
];
